import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SEO Head component for page-specific meta tags
 * Updates document head based on route
 */
const SEOHead = ({ 
  title, 
  description, 
  keywords = '', 
  canonicalPath = '',
  ogImage = '',
  ogType = 'website',
  noindex = false 
}) => {
  const location = useLocation();
  const baseUrl = 'https://gegadyne.com';
  const defaultOgImage = 'https://static.prod-images.emergentagent.com/jobs/33c31e00-1f67-4b7c-b75b-87a0800910cc/images/8a35023f172654796dbf802598cc794412da0fe49caa88b8c00ef4211688f9e0.png';
  
  const fullTitle = title 
    ? `${title} | Gegadyne Energy` 
    : 'Gegadyne Energy | Multi-Ion™ Industrial Batteries | Traction, ESS & Ground Power Systems';
  
  const fullDescription = description || 
    'Leading industrial battery manufacturer in India. Multi-Ion traction batteries, energy storage systems, ground power units. Fast charging, high cycle life. Made in India.';
  
  const canonicalUrl = `${baseUrl}${canonicalPath || location.pathname}`;
  const imageUrl = ogImage || defaultOgImage;

  useEffect(() => {
    // Update title
    document.title = fullTitle;
    
    // Update meta tags
    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };
    
    // Standard meta tags
    updateMeta('description', fullDescription);
    if (keywords) updateMeta('keywords', keywords);
    updateMeta('robots', noindex ? 'noindex, nofollow' : 'index, follow');
    
    // Open Graph
    updateMeta('og:title', fullTitle, true);
    updateMeta('og:description', fullDescription, true);
    updateMeta('og:url', canonicalUrl, true);
    updateMeta('og:type', ogType, true);
    updateMeta('og:image', imageUrl, true);
    
    // Twitter
    updateMeta('twitter:title', fullTitle);
    updateMeta('twitter:description', fullDescription);
    updateMeta('twitter:image', imageUrl);
    
    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', canonicalUrl);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', canonicalUrl);
      document.head.appendChild(canonical);
    }
    
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [fullTitle, fullDescription, keywords, canonicalUrl, ogType, imageUrl, noindex]);

  return null;
};

export default SEOHead;
